/**
 * Created by jbz on 2017/10/16.
 */
// 个人信息
export const ACCOUNT = {
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT_MUTATION'
};

// 全局变量
export const GLOBAL_VARIABLE = {
  UPDATE_TEST:'UPDATE_TEST_MUTATION',
  UPDATE_TRADE:'UPDATE_TRADE_MUTATION',
  UPDATE_CACHE: 'UPDATE_CACHE_MUTATION',
  UPDATE_JUMP: 'UPDATE_JUMP_MUTATION',
  UPDATE_FILM: 'UPDATE_FILM_MUTATION',
  UPDATE_CINEMA: 'UPDATE_CINEMA_MUTATION',
  UPDATE_RANK: 'UPDATE_RANK_MUTATION',
  UPDATE_ACTIVITY: 'UPDATE_ACTIVITY_MUTATION'
};
// locationModule
export const LOCATION = {
  UPDATE_LOCATION: 'UPDATE_LOCATION_MUTATION',
  UPDATE_LOCATION_CITY: 'UPDATE_LOCATION_CITY_MUTATION',
  UPDATE_USER_LOCATION_CITY: 'UPDATE_USER_LOCATION_CITY_MUTATION'
};

// rootModule
export const SHOW_LOADING = 'SHOW_LOADING_MUTATION';

export const ALERT = {
  CITY_ALERT: 'CITY_ALERT_MUTATION'
};
